import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hourslaw.token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Auth
export async function signIn(payload){ const { data } = await api.post('/auth/signin', payload); return data; }
export async function signUp(payload){ const { data } = await api.post('/auth/signup', payload); return data; }
export async function getMe(){ const { data } = await api.get('/auth/me'); return data; }

// Matters & Tags
export async function fetchMatters(){ const { data } = await api.get('/projects'); return data; }
export async function createMatter(payload){ const { data } = await api.post('/projects', payload); return data; }
export async function updateMatter(id, patch){ const { data } = await api.patch(`/projects/${id}`, patch); return data; }
export async function deleteMatter(id){ const { data } = await api.delete(`/projects/${id}`); return data; }
export async function mergeMatters(sourceId, targetId){ const { data } = await api.post('/projects/merge', { sourceId, targetId }); return data; }

export async function fetchTags(){ const { data } = await api.get('/tags'); return data; }
export async function createTag(payload){ const { data } = await api.post('/tags', payload); return data; }
export async function updateTag(id, patch){ const { data } = await api.patch(`/tags/${id}`, patch); return data; }
export async function deleteTag(id){ const { data } = await api.delete(`/tags/${id}`); return data; }

export async function fetchProjects(){ return fetchMatters(); }

// Entries
export async function fetchEntries({ from, to }){ const params = {}; if (from) params.from_ = from; if (to) params.to = to; const { data } = await api.get('/entries', { params }); return data; }
export async function createEntry(payload){ const { data } = await api.post('/entries', payload); return data; }
export async function updateEntry(id, patch){ const { data } = await api.patch(`/entries/${id}`, patch); return data; }
export async function deleteEntry(id){ const { data } = await api.delete(`/entries/${id}`); return data; }

// Reports
export async function fetchDailyReport({ from, to, users, clientId, projectId, tagId }){
  const params = {}; if (from) params.from_ = from; if (to) params.to = to;
  if (users && users.length) params.users = users.join(',');
  if (clientId) params.clientId = clientId;
  if (projectId) params.projectId = projectId;
  if (tagId) params.tagId = tagId;
  const { data } = await api.get('/reports/daily', { params }); return data;
}
export async function fetchSummaryReport({ from, to, users, clientId, projectId, tagId }){
  const params = {}; if (from) params.from_ = from; if (to) params.to = to;
  if (users && users.length) params.users = users.join(',');
  if (clientId) params.clientId = clientId;
  if (projectId) params.projectId = projectId;
  if (tagId) params.tagId = tagId;
  const { data } = await api.get('/reports/summary', { params }); return data;
}
export async function fetchDailyByUser({ from, to, users, clientId, projectId, tagId }){
  const params = {}; if (from) params.from_ = from; if (to) params.to = to;
  if (users && users.length) params.users = users.join(',');
  if (clientId) params.clientId = clientId;
  if (projectId) params.projectId = projectId;
  if (tagId) params.tagId = tagId;
  const { data } = await api.get('/reports/daily_by_user', { params }); return data;
}

// Import CSV
export async function importCSV(formData, onUploadProgress){
  const { data } = await api.post('/import/csv', formData, { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress });
  return data;
}

// Admin
export async function fetchUsers(){ const { data } = await api.get('/admin/users'); return data; }
export async function fetchUsersLite(){ const { data } = await api.get('/admin/users-lite'); return data; }
export async function updateUserRole(userId, role){ const { data } = await api.patch(`/admin/users/${userId}/role`, { role }); return data; }
export async function updateUserRate(userId, rate){ const { data } = await api.patch(`/admin/users/${userId}/rate`, { rate }); return data; }
export async function deleteUser(uid){ const { data } = await api.delete(`/admin/users/${uid}`); return data; }
export async function changePassword(currentPassword, newPassword){ const { data } = await api.post('/auth/change-password', { currentPassword, newPassword }); return data; }
export async function adminResetUserPassword(uid, newPassword){ const { data } = await api.post(`/admin/users/${uid}/reset-password`, { newPassword }); return data; }
export async function reassignEntries(entryIds, userId){ const { data } = await api.post('/admin/entries/reassign', { entryIds, userId }); return data; }
export async function fetchAnalytics({ from, to, projectId }){
  const params = {}; if (from) params.from_ = from; if (to) params.to = to; if (projectId) params.projectId = projectId;
  const { data } = await api.get('/reports/analytics', { params }); return data;
}

// Groups
export async function fetchGroups(){ const { data } = await api.get('/admin/groups'); return data; }
export async function createGroup(payload){ const { data } = await api.post('/admin/groups', payload); return data; }
export async function deleteGroup(id){ const { data } = await api.delete(`/admin/groups/${id}`); return data; }

// Invites
export async function createInvite(email){ const { data } = await api.post('/admin/invites', { email }); return data; }
export async function fetchInvites(){ const { data } = await api.get('/admin/invites'); return data; }
export async function deleteInvite(id){ const { data } = await api.delete(`/admin/invites/${id}`); return data; }

// Backup
export async function downloadBackup(){ const res = await api.get('/admin/backup.zip', { responseType: 'blob' }); return res; }
export async function downloadEntriesBackup(){ const res = await api.get('/admin/backup_entries.zip', { responseType: 'blob' }); return res; }

// S3 Backup
export async function getBackupStatus(){ const { data } = await api.get('/backup/status'); return data; }
export async function triggerS3Backup(){ const { data } = await api.post('/backup/trigger'); return data; }
export async function listS3Backups(){ const { data } = await api.get('/backup/list'); return data; }
export async function getBackupDownloadUrl(s3Key){ const { data } = await api.get(`/backup/download/${s3Key}`); return data; }
export async function sendTestBackupEmail(){ const { data } = await api.post('/backup/test-email'); return data; }

// Calendar
export async function fetchCalendarEvents({ from, to, caseId, type }){
  const params = {}; if (from) params.from_ = from; if (to) params.to = to; if (caseId) params.caseId = caseId; if (type) params.type = type;
  const { data } = await api.get('/calendar/events', { params }); return data;
}
export async function createCalendarEvent(payload){ const { data } = await api.post('/calendar/events', payload); return data; }
export async function updateCalendarEvent(id, patch){ const { data } = await api.patch(`/calendar/events/${id}`, patch); return data; }
export async function deleteCalendarEvent(id){ const { data } = await api.delete(`/calendar/events/${id}`); return data; }

export async function fetchCalendarCases(){ const { data } = await api.get('/calendar/cases'); return data; }
export async function createCalendarCase(payload){ const { data } = await api.post('/calendar/cases', payload); return data; }
export async function updateCalendarCase(id, patch){ const { data } = await api.patch(`/calendar/cases/${id}`, patch); return data; }
export async function deleteCalendarCase(id){ const { data } = await api.delete(`/calendar/cases/${id}`); return data; }

export async function fetchCalendarCategories(){ const { data } = await api.get('/calendar/categories'); return data; }
export async function createCalendarCategory(payload){ const { data } = await api.post('/calendar/categories', payload); return data; }
export async function updateCalendarCategory(id, patch){ const { data } = await api.patch(`/calendar/categories/${id}`, patch); return data; }
export async function deleteCalendarCategory(id){ const { data } = await api.delete(`/calendar/categories/${id}`); return data; }
export async function initDefaultCategories(){ const { data } = await api.post('/calendar/categories/init-defaults'); return data; }

